import { callApiWithAuthorization } from "../CallApi";

export async function getAttributeTemplates(organizationId) {
    let request = await callApiWithAuthorization("/api/v0/organization/" + organizationId + "/attributeTemplates");
    let response = await request.json();
    return response;
}

export async function getAttributeTemplate(attributeTemplateId) {
    let request = await callApiWithAuthorization("/api/v0/attributeTemplate/" + attributeTemplateId);
    let response = await request.json();
    return response;
}

export async function createAttributeTemplate(organizationId, properties) {
    let request = await callApiWithAuthorization("/api/v0/organization/" + organizationId + "/attributeTemplate", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(properties)
    });
    let response = await request.json();
    return response;
}

export async function updateAttributeTemplate(attributeTemplateId, properties) {
    let request = await callApiWithAuthorization("/api/v0/attributeTemplate/" + attributeTemplateId, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(properties)
    });
    let response = await request.json();
    return response;
}

export async function deleteAttributeTemplate(attributeTemplateId) {
    let request = await callApiWithAuthorization("/api/v0/attributeTemplate/" + attributeTemplateId, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
        }
    });
    let response = await request.json();
    return response;
}